/* Scroll to top button (snippets/scroll-to-top.liquid). */
(function () {
  var button = document.querySelector('[data-stt]');
  if (!button) return;

  var threshold = parseInt(button.getAttribute('data-threshold'), 10) || 400;
  var ticking = false;

  function update() {
    ticking = false;
    var visible = window.scrollY > threshold;
    if (visible === button.classList.contains('is-visible')) return;
    button.classList.toggle('is-visible', visible);
    // Hidden button stays out of the tab order and the accessibility tree.
    button.setAttribute('aria-hidden', String(!visible));
    button.tabIndex = visible ? 0 : -1;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    },
    { passive: true }
  );

  button.addEventListener('click', function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    // The button hides once at the top; don't leave focus on it.
    button.blur();
  });

  update();
})();
